<script>
	import { handleNameChange } from "../helpers";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Checkbox from "./Checkbox.svelte";

	export let partnershipName;
	export let partnershipMembers;
	export let authorisedToAct;
	export let disabled = null;
	export let required = null;
</script>

<h3>Partnership Details</h3>

<FormRow>
	<FormColumn cols="6">
		<label for="partnershipName" class:isrequired={required}>Partnership Name</label>
		<input
			{disabled}
			{required}
			maxlength="1000"
			type="text"
			bind:value={partnershipName}
			id="partnershipName"
			class="form-control"
			on:change={() => (partnershipName = handleNameChange(partnershipName))} />
	</FormColumn>
	<FormColumn cols="6">
		<label for="partnershipMembers">Partnership Members</label>
		<input
			{disabled}
			type="text"
			bind:value={partnershipMembers}
			id="partnershipMembers"
			class="form-control"
			on:change={() => (partnershipMembers = handleNameChange(partnershipMembers))} />
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to act on behalf of the Partnership"
			{required}
			id="authp"></Checkbox>
	</FormColumn>
</FormRow>
